import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import type { EmployeeManualOrder } from '@/api/employee-manual-order'

interface ManualOrderConfirmPaymentDialogProps {
  order: EmployeeManualOrder | null
  open: boolean
  isSubmitting?: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

export function ManualOrderConfirmPaymentDialog({
  order,
  open,
  isSubmitting = false,
  onOpenChange,
  onConfirm,
}: ManualOrderConfirmPaymentDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogTitle>确认收款</DialogTitle>
          <DialogDescription>
            确认后订单将标记为已支付，并进入待发货状态。
          </DialogDescription>
        </DialogHeader>

        {order && (
          <div className="rounded-md border bg-muted/30 p-4 text-sm">
            <div className="text-muted-foreground">订单号</div>
            <div className="font-mono font-medium">{order.order_id}</div>
            <div className="mt-3 text-muted-foreground">收款金额</div>
            <div className="text-xl font-bold text-red-600">¥{order.pay_price.toFixed(2)}</div>
            <div className="mt-3 text-muted-foreground">收货人</div>
            <div>{order.real_name || '-'} {order.user_phone || ''}</div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            取消
          </Button>
          <Button onClick={onConfirm} disabled={!order || isSubmitting}>
            {isSubmitting ? '确认中...' : '确认收款'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
